import React, { Component } from 'react';
import lodash from 'lodash';

import { Button }  from 'primereact/button';
import { Message } from 'primereact/message';
import { Divider } from 'primereact/divider';

import { ModelTextInput } from 'hay-core-react';
import { ModelSenha } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import LogoInicial   from '../../images/LogoInicial.png';
import { withRouter } from 'hay-core-react';
class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model: {
                identificador: {
                    value:     '',
                    erro:      '',
                    exibir:    'login.identificador',
                    validacao: { obrigatorio: true },
                },
                senha: {
                    value:     '',
                    erro:      '',
                    exibir:    'login.senha',
                    validacao: { obrigatorio: true, tamanhominimo: 6 },
                },
            },
            grupos:         [],
            selecionarGrupo: false,
            redefinirSenha:  false,
            erroGeral:      '',
            carregando:     false,
        };
    }

    async componentDidMount() {
        const auth = UtilService.getLocalStorage('auth');
        if (!auth?.token) return;
        const resultado = await ApiService.autorizar();
        const result = resultado?.data;
        if (result?.nome && result?.token) {
            UtilService.saveLocalStorage('auth', { ...auth, ...result });
            this.props.setPermissoes && this.props.setPermissoes({ ...(result?.permissoes || {}), permiteacessogeral: result?.permiteacessogeral, acessototal: result?.acessototal }, () => {
                this.navegarPosLogin();
            });
        }
    }

    // Honra ?destino=<url> (gerado por PaginaNaoExiste quando uma rota protegida ainda não
    // estava registrada) — sem ele, cai na rota padrão.
    navegarPosLogin() {
        const destino = this.props.searchparams?.get('destino');
        if (destino) {
            const [pathname, search] = destino.split('?');
            return this.props.navigate({
                pathname,
                search: search ? Object.fromEntries(new URLSearchParams(search)) : undefined,
            });
        }
        this.props.navigate({ pathname: '/dashboard' });
    }

    // ── Interface contexto — mesma que EntityGrid expõe em `this` ────────────

    traduzir(chave) {
        return UtilService.traduzir(chave);
    }

    traduzirModel(model) {
        return this.traduzir(model.exibir);
    }

    traduzirHelp() {
        return '';
    }

    getRenderer(path) {
        return lodash.get({
            gruposDisponiveis: {
                getOptions: () => this.state.grupos.map(g => ({ id: g.id, descricao: g.nome })),
            },
        }, path);
    }

    updateModelPath(path, valor) {
        this.setState(prevState => {
            const obj = lodash.cloneDeep(prevState.model);
            lodash.set(obj, path, valor);
            return { model: obj };
        });
    }

    // ── Lógica de login ───────────────────────────────────────────────────────

    async handleSubmit() {
        const model = UtilService.validarEsquema(this.state.model);
        this.setState({ model, erroGeral: '' });
        if (!model.valido) return;

        this.setState({ carregando: true });

        if (this.state.redefinirSenha) {
            const novaSenha = model.novaSenha.value;
            const troca = await ApiService.trocarSenhaPendente(
                model.identificador.value.trim(),
                model.senha.value,
                novaSenha,
                model.novaSenhaConf.value,
            );
            if (!troca?.status) {
                return this.setState({ carregando: false, erroGeral: this.traduzir(troca?.data?.state) || troca?.data?.message });
            }
            return this.setState(prevState => ({
                redefinirSenha: false,
                carregando: false,
                erroGeral: '',
                model: {
                    ...lodash.omit(prevState.model, ['novaSenha', 'novaSenhaConf']),
                    senha: { ...prevState.model.senha, value: novaSenha, erro: '' },
                },
            }), () => this.handleSubmit());
        }

        const grupo = this.state.selecionarGrupo ? model.grupo.value?.id : undefined;
        const result  = await ApiService.login(model.identificador.value.trim(), model.senha.value, grupo);

        if (result?.status && result?.data?.token) {
            UtilService.saveLocalStorage('auth', result.data);
            this.props.setPermissoes && this.props.setPermissoes({ ...(result.data.permissoes || {}), permiteacessogeral: result.data.permiteacessogeral, acessototal: result.data.acessototal }, () => {
                this.navegarPosLogin();
            });
        } else if (result?.data?.state === 'menu.mensagem.login.selecionar.grupo') {
            this.setState(prevState => ({
                carregando:      false,
                selecionarGrupo: true,
                grupos:          result.data.grupos || [],
                erroGeral:       this.traduzir(result.data.state) || result.data.message,
                model: {
                    ...prevState.model,
                    grupo: {
                        value:    null,
                        erro:     '',
                        exibir:   'login.grupo',
                        entidade: 'gruposDisponiveis',
                        validacao: { obrigatorio: true },
                    },
                },
            }));
        } else if (result?.data?.state === 'menu.mensagem.login.redefinir.senha.obrigatoria') {
            this.setState(prevState => ({
                carregando: false,
                redefinirSenha: true,
                erroGeral: this.traduzir(result.data.state),
                model: {
                    ...prevState.model,
                    // ModelSenha usa o ultimo segmento de `exibir` como path do model. Por isso
                    // as chaves precisam terminar exatamente em novaSenha/novaSenhaConf.
                    novaSenha: { value: '', erro: '', exibir: 'login.novaSenha', validacao: { obrigatorio: true, tamanhominimo: 6, identico: { campo: 'novaSenhaConf', descricao: 'login.novaSenhaConf' } } },
                    novaSenhaConf: { value: '', erro: '', exibir: 'login.novaSenhaConf', validacao: { obrigatorio: true, tamanhominimo: 6, identico: { campo: 'novaSenha', descricao: 'login.novaSenha' } } },
                },
            }));
        } else {
            this.setState({
                carregando: false,
                erroGeral:  result?.data?.message || this.traduzir('login.erro.credenciais'),
            });
        }
    }

    handleKeyDown(e) {
        if (e.key === 'Enter') this.handleSubmit();
    }

    render() {
        const { model, erroGeral, carregando, selecionarGrupo, redefinirSenha } = this.state;

        return (
            <div className="min-h-screen flex align-items-center justify-content-center surface-ground px-3 py-3 ">
                <div
                    className="surface-card border-round-2xl shadow-4 w-full p-5 md:p-6"
                    style={{ maxWidth: '440px' }}
                >
                    {/* ── Logo ────────────────────────────────────────────── */}
                    <div className="flex flex-column align-items-center mb-5">
                        <img
                            src={LogoInicial}
                            alt="HaY Systems"
                            style={{ objectFit: 'contain' }}
                            className="w-full mb-3"
                        />
                        <span className="font-bold text-3xl text-primary">{this.traduzir('login.titulo')}</span>
                        <span className="text-500 text-sm mt-1">{this.traduzir('login.subtitulo')}</span>
                    </div>

                    <Divider className="mt-4 mb-5" />

                    {/* ── Campos ──────────────────────────────────────────── */}
                    <div className="field mb-5" onKeyDown={e => this.handleKeyDown(e)}>
                        <ModelTextInput model={model.identificador} contexto={this} />
                    </div>

                    <div className="field mb-2" onKeyDown={e => this.handleKeyDown(e)}>
                        <ModelSenha model={model.senha} contexto={this} mostrarMetricas={false} />
                    </div>

                    <div className="flex justify-content-end mb-5">
                        <Button label={this.traduzir('login.esqueci.senha')} link onClick={() => this.props.navigate({ pathname: '/esqueci-senha' })} className="p-0" size="small" />
                    </div>

                    {redefinirSenha && (
                        <>
                            <div className="field mb-4"><ModelSenha model={model.novaSenha} contexto={this} mostrarMetricas={true} /></div>
                            <div className="field mb-5"><ModelSenha model={model.novaSenhaConf} contexto={this} mostrarMetricas={false} /></div>
                        </>
                    )}

                    {/* ── Seleção de grupo ────────────────────────────────── */}
                    {selecionarGrupo && (
                        <div className="field mb-5">
                            <ModelDropDown model={model.grupo} contexto={this} />
                        </div>
                    )}

                    {/* ── Erro geral ──────────────────────────────────────── */}
                    {erroGeral && (
                        <Message
                            severity="error"
                            text={erroGeral}
                            className="w-full mb-4"
                            style={{ justifyContent: 'flex-start' }}
                        />
                    )}

                    {/* ── Botão ───────────────────────────────────────────── */}
                    <Button
                        label={this.traduzir(redefinirSenha ? 'login.salvar.nova.senha' : 'login.entrar')}
                        icon="pi pi-sign-in"
                        loading={carregando}
                        onClick={() => this.handleSubmit()}
                        className="w-full"
                        size="small"
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(LoginPage);
